import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { MessageService } from 'primeng/api';
import { ErrorDialogComponent } from './error-dialog.component';

@Injectable({
	providedIn: 'root',
})
export class ErrorService {
	dialogRef: DynamicDialogRef | null | undefined;

	constructor(
		private router: Router,
		private dialogService: DialogService,
		private messageService: MessageService,
	) {}

	getError(errorMessage?: string): void {
		this.router.navigate([this.router.url]);
		this.openModalError(errorMessage);
	}

	openModalError(errorMessage?: string): void {
		this.dialogRef = this.dialogService.open(ErrorDialogComponent, {
			header: 'Error',
			width: '50%',
			contentStyle: { overflow: 'auto' },
			baseZIndex: 10000,
			maximizable: true,
			data: {
				message: errorMessage,
			},
		});

		this.dialogRef?.onClose?.subscribe((result) => {
			if (result) {
				// Handle dialog close with result
			}
		});
	}

	openModal(title: string, message: string, modalColor?: string): void {
		this.dialogRef = this.dialogService.open(ErrorDialogComponent, {
			header: title,
			width: '50%',
			contentStyle: { overflow: 'auto' },
			baseZIndex: 10000,
			maximizable: true,
			data: {
				message: message,
				color: modalColor,
			},
		});

		this.dialogRef?.onClose?.subscribe((result) => {
			if (result) {
				// Handle dialog close with result
			}
		});
	}
}
